document.addEventListener('DOMContentLoaded', function() {
    // Fonction pour initialiser l'interaction entre l'arbre et les cartes
    function initKabbalahTree() {
        const sectionId = document.querySelector('.kabbalah-tree-section').id;
        const sephiroth = document.querySelectorAll(`#${sectionId} .sephirah`);
        const cards = document.querySelectorAll(`#${sectionId} .card`);
        
        // Créer un mapping dynamique entre les IDs des sephiroth et des cartes
        const mapping = {};
        sephiroth.forEach(sephirah => {
            const sephirahId = sephirah.id;
            mapping[sephirahId] = `card-${sephirahId}`;
        });
        
        // Ajouter des écouteurs d'événements aux sephiroth
        sephiroth.forEach(sephirah => {
            sephirah.addEventListener('click', () => {
                // Réinitialiser toutes les sephiroth et cartes
                sephiroth.forEach(s => {
                    s.classList.remove('active');
                });
                cards.forEach(c => {
                    c.classList.remove('active');
                });
                
                // Mettre en évidence la sephirah sélectionnée
                sephirah.classList.add('active');
                
                // Obtenir l'ID correspondant à la carte
                const sephirahId = sephirah.id;
                const cardId = mapping[sephirahId];
                
                // Activer la carte correspondante
                const targetCard = document.getElementById(cardId);
                if (targetCard) {
                    targetCard.classList.add('active');
                    
                    // Faire défiler vers la carte
                    targetCard.scrollIntoView({ behavior: 'smooth', block: 'center' });
                }
            });
        });
        
        // Permettre la navigation inverse (cliquer sur une carte active la sephirah correspondante)
        cards.forEach(card => {
            card.addEventListener('click', () => {
                // Réinitialiser toutes les sephiroth et cartes
                sephiroth.forEach(s => {
                    s.classList.remove('active');
                });
                cards.forEach(c => {
                    c.classList.remove('active');
                });
                
                // Activer la carte
                card.classList.add('active');
                
                // Trouver la sephirah correspondante
                const cardId = card.id;
                const sephirahId = Object.keys(mapping).find(key => mapping[key] === cardId);
                
                // Activer la sephirah correspondante
                const targetSephirah = document.getElementById(sephirahId);
                if (targetSephirah) {
                    targetSephirah.classList.add('active');
                    
                    // Faire défiler vers la sephirah
                    targetSephirah.scrollIntoView({ behavior: 'smooth', block: 'center' });
                }
            });
        });
    }
    
    // Initialiser l'arbre de la Kabbale
    initKabbalahTree();
    
    // Pour Shopify, réinitialiser lorsque la section est rechargée via l'éditeur de thème
    if (Shopify && Shopify.designMode) {
        document.addEventListener('shopify:section:load', function(event) {
            if (event.target.classList.contains('kabbalah-tree-section')) {
                initKabbalahTree();
            }
        });
    }
});